module.exports = __webpack_public_path__ + "img/hottub_2.9f66865e.jpg";